import React from 'react'
import { strapiDateToString, getStrapiMedia } from '../lib/strapi/helpers'
import { BlogPostType } from '../lib/strapi/responseTypes'
import { ContentCardImageOnTop } from './ContentCardImageOnTop'
import { Link, LinkVariant } from './Link'

export function BlogPostCard({ ...post }: BlogPostType) {
  return (
    <ContentCardImageOnTop
      imgSrc={getStrapiMedia(post.attributes.coverImage.data.attributes.url)}
      imgAlt={post.attributes.coverImage.data.attributes.alternativeText}
      title={post.attributes.title}
      content={
        <>
          <span className="block mb-6">
            {strapiDateToString(post.attributes.datePublished)}
          </span>
          <span className="block">{post.attributes.excerpt}</span>
        </>
      }
      cardHref={`/blog/${post.attributes.slug}`}
    >
      <Link
        href={`/blog/${post.attributes.slug}`}
        variant={LinkVariant.FORWARD}
        translationKey={'readBlogArticle'}
      />
    </ContentCardImageOnTop>
  )
}
